// src/components/Item/CityUpdates.jsx
// Admin: şehirlerin en son ne zaman stok güncellediği (en eski önce)

import React from "react";
import styles from "./StockReports.module.css";

const STALE_DAYS = 30;
const DAY_MS = 24 * 60 * 60 * 1000;

const CityUpdates = ({ users, onCityClick }) => {
  const now = Date.now();

  const rows = (users || [])
    .filter((u) => !u.isSuperAdmin)
    .map((u) => {
      const assigned = (u.assignedItems || []).filter((ai) => ai.item);
      const lastUpdate = assigned.reduce((latest, ai) => {
        const t = ai.stockUpdatedAt ? new Date(ai.stockUpdatedAt).getTime() : 0;
        return t > latest ? t : latest;
      }, 0);
      return {
        id: u._id,
        name: u.name,
        lastUpdate,
        daysAgo: lastUpdate ? Math.floor((now - lastUpdate) / DAY_MS) : null,
        itemCount: assigned.length,
        totalStock: assigned.reduce((sum, ai) => sum + (ai.count || 0), 0),
      };
    })
    // Hiç güncellemeyenler en üstte, sonra en eski güncelleyenler
    .sort((a, b) => a.lastUpdate - b.lastUpdate);

  return (
    <div className={styles.tableWrap}>
      <p className={styles.muted}>
        {STALE_DAYS} günden uzun süredir güncelleme yapmayan şehirler işaretlidir.
      </p>
      <table className={styles.table}>
        <thead>
          <tr>
            <th>Şehir</th>
            <th>Son Güncelleme</th>
            <th>Ürün</th>
            <th>Toplam Stok</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const stale = r.daysAgo === null || r.daysAgo > STALE_DAYS;
            return (
              <tr key={r.id} className={stale ? styles.staleRow : ""}>
                <td>
                  <button
                    type="button"
                    className={styles.linkButton}
                    onClick={() => onCityClick(r.id)}
                  >
                    {r.name}
                  </button>
                </td>
                <td>
                  {r.lastUpdate
                    ? `${new Date(r.lastUpdate).toLocaleDateString("tr-TR")} (${
                        r.daysAgo === 0 ? "bugün" : `${r.daysAgo} gün önce`
                      })`
                    : "Hiç güncellenmedi"}
                </td>
                <td>{r.itemCount}</td>
                <td>{r.totalStock}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CityUpdates;
